gsap.registerPlugin(MotionPathPlugin)
gsap.registerPlugin(ScrollTrigger)

/**
 *
 * @param trigger {string}
 * @param targetSelector {string}
 * @param animationLength {{length: number, mobileLength: number} | number}
 * @param mode {'top-bottom' | 'default'}
 * @param direction {'up' | 'down'}
 */
function addParallax(trigger, targetSelector, animationLength, mode, direction = 'up') {
  const target = document.querySelector(targetSelector);
  if (!target) {
    return;
  }
  createParallaxAnimation(trigger, target, animationLength, mode, direction);
}

/**
 *
 * @param trigger {string}
 * @param targetsSelector {string}
 * @param animationLength {{length: number, mobileLength: number} | number}
 * @param mode {'top-bottom' | 'default'}
 * @param direction {'up' | 'down'}
 */
function addParallaxMultiple(trigger, targetsSelector, animationLength, mode, direction = 'up') {
  const targets = Array.prototype.slice.call(document.querySelectorAll(targetsSelector));
  targets
    .filter(Boolean)
    .forEach((target) => {
      createParallaxAnimation(trigger, target, animationLength, mode, direction);
    })
}

/**
 *
 * @param trigger {string}
 * @param target {Element}
 * @param animationLength {{length: number, mobileLength: number} | number}
 * @param mode {'top-bottom' | 'default'}
 * @param direction {'up' | 'down'}
 */
function createParallaxAnimation(trigger, target, animationLength, mode, direction = 'up') {
  let timeline;
  const createParallax = () => {
    if (timeline) {
      timeline.seek(0);
      timeline.kill();
    }
    //TODO: temporarily disabled mobile parallax - adress bar showing and hiding issues
    if (window.innerWidth <= 1024) {
      return;
    }
    let originPosition;
    let targetPosition;
    if (window.innerWidth < 992 && animationLength.mobileLength !== undefined) {
      if (animationLength.mobileLength === 0) {
        return;
      }
      originPosition = direction === 'up' ? animationLength.mobileLength : -animationLength.mobileLength;
      targetPosition = direction === 'up' ? -animationLength.mobileLength : animationLength.mobileLength;
    } else {
      const length = animationLength.length ?? animationLength;
      originPosition = direction === 'up' ? length : -length;
      targetPosition = direction === 'up' ? -length : length;
    }

    if (mode === 'default') {
      timeline = getToParallaxAnimation(target, targetPosition, trigger)
    } else {
      timeline = getFromToParallaxAnimation(target, originPosition, targetPosition, trigger)
    }
  }
  createParallax();
  window.addEventListener('resize', () => {
    createParallax();
  })
}

/**
 *
 * @param target {string|Object|Array}
 * @param path {string|Object|Array}
 * @param animationLength {number}
 * @param start {number}
 * @param end {number}
 * @returns {gsap.Timeline}
 */
function createPathAnimation(target, path, animationLength, start = 0.5, end = 1.5) {
  const timeline = gsap.timeline({
    delay: 0,
  })

  timeline.to(target, {
    motionPath: {
      path: path,
      align: path,
      alignOrigin: [0.5, 0.5],
      start,
      end,
    },
    ease: 'none',
    duration: animationLength,
    repeat: 33
  });

  window.addEventListener('resize', function () {
    timeline.invalidate();
  })

  return timeline;
}

/**
 * Creates raising points animation in GSAP
 * @param trigger {string}
 * @param targets {string}
 * @param path {string}
 */
function createRaisingAnimation(trigger, targets, path) {
  const tl = gsap.to(targets, {
    motionPath: {
      path: path,
      align: path,
      alignOrigin: [0.5, 0.5],
    },
    scrollTrigger: {
      trigger,
      start: "top 60%",
      end: "bottom 60%",
      invalidateOnRefresh: true,
      scrub: true
    },
    ease: 'none',
  });

  window.addEventListener('resize', function () {
    tl.invalidate();
  })
}

/**
 * Creates raising points animation in GSAP
 * @param target {Element}
 * @param targetPosition {number}
 * @param trigger {string}
 */
function getToParallaxAnimation(target, targetPosition, trigger) {
  return gsap.to(target, {
    yPercent: targetPosition,
    ease: "none",
    scrollTrigger: {
      trigger: trigger,
      start: 0,
      end: "max",
      invalidateOnRefresh: true,
      scrub: true,
    }
  });
}

/**
 * Creates raising points animation in GSAP
 * @param target {Element}
 * @param originPosition {number}
 * @param targetPosition {number}
 * @param trigger {string}
 */
function getFromToParallaxAnimation(target, originPosition, targetPosition, trigger) {
  return gsap.fromTo(target, {
    yPercent: originPosition,
  }, {
    yPercent: targetPosition,
    ease: "none",
    scrollTrigger: {
      trigger: trigger,
      start: "top bottom",
      end: "bottom top",
      invalidateOnRefresh: true,
      scrub: true
    }
  });
}

/**
 * Creates animations chained together
 * @param trigger {object}
 * @param animations {Array.<{selector: string, from: Object, to: Object, position: string}>}
 */
function chainFromToAnimations(trigger, animations) {
  const timeline = gsap.timeline({paused: true, scrollTrigger: {trigger: trigger, start: 'top 55%'}},);
  animations.forEach((animation, index) => {
    const {selector, from, to, position} = animation;
    timeline.fromTo(selector, from, to, position ?? '<0.3');
  });
  return timeline;
}
